import { Text, Image } from "@mantine/core";
import React from "react";
import { useHref } from "react-router-dom";
import { getSiteDeploymentStatus } from "../../../../../Utils/Functions";
import { getValueFromConfigWithOverrides } from "../../../../../Config";
import { webPlayerStore } from "@app/Screens/WebPlayer/store/webPlayerStore";

/** Лого компании */
export const CompanyLogoSection = (props: { width?: number }) => {
	const gameConfig = webPlayerStore((state) => state.gameConfig);
	const portalConfig = webPlayerStore((state) => state.portalConfig);
	const adapter = webPlayerStore((state) => state.adapter);

	const WebPlayerLogo =
		getValueFromConfigWithOverrides<string>(
			portalConfig,
			"Logos.WebPlayerLogo",
			"HeaderLogo",
			adapter,
			gameConfig
		) ?? "";

	const isLogoText = !isURL(WebPlayerLogo);

	return (
		<div className="header-logo" style={{ width: props.width ? Math.max(props.width, 76) : undefined }}>
			<LogoWrapper>
				{isLogoText ? (
					<Text fw="bold">{WebPlayerLogo}</Text>
				) : (
					<Image src={WebPlayerLogo} height={24} width={92} />
				)}
			</LogoWrapper>
		</div>
	);
};

const LogoWrapper = (props: { children: React.ReactNode }) => {
	const homeHref = useHref("/");
	const { isIframe } = getSiteDeploymentStatus();
	if (isIframe) return <>{props.children}</>;
	return (
		<a target="_blank" href={homeHref} className="header-logo-link" rel="noreferrer">
			{props.children}
		</a>
	);
};

function isURL(possibleUrl: string) {
	return possibleUrl.startsWith("http") || possibleUrl.startsWith("/static");
}
